import { forwardRef, memo } from 'react';
import type { StepFormApi } from '@/hooks/useStepValidation';
import type { ScheduleStepProps } from '../../config/types';
import { ScorecardStep as SharedScorecardStep } from '../../../components/ScorecardStep';
import { SCHEDULE_INTERVIEW_COPY } from '../../config/copy';
import { useScorecardVisibilitySettings } from '@/pages/settings/interview-and-scheduling/score-card/home/api';

export const ScorecardStep = memo(
  forwardRef<StepFormApi, ScheduleStepProps>((props, ref) => {
    const { data: scorecardSettings } = useScorecardVisibilitySettings();
    const showAiToggle = Boolean(
      scorecardSettings?.data?.account_setting?.fill_with_ai_enabled
    );
    return (
      <SharedScorecardStep
        ref={ref}
        payloadRef={props.payloadRef}
        prefillVersion={props.prefillVersion}
        copy={SCHEDULE_INTERVIEW_COPY.scorecard}
        interviewPlan={props.interviewPlan}
        showAiToggle={showAiToggle}
      />
    );
  })
);

ScorecardStep.displayName = 'ScorecardStep';
